import { Action } from '@ngrx/store';
import { Datepicker } from './../models/datepicker.model';

//FIXME: Most of these are derived state that belongs to a selector
export enum ActionTypes {
    ENABLE_DATEPICKER                           = '[Financial Documents Layout] Enable Datepicker',
    DISABLE_DATEPICKER                          = '[Financial Documents Layout] Disable Datepicker',
    ENABLE_STATUS_OPTION_BY_VOLUME_OF_DATA      = '[Financial Documents Layout] Enable Status Option By Volume Of Data',
    DISABLE_STATUS_OPTION_BY_VOLUME_OF_DATA     = '[Financial Documents Layout] Disable Status Option By Volume Of Data',
    SET_DATEPICKER_RANGE_VALUE                  = '[Financial Documents Layout] Set Datepicker Range Value',
    SET_VIEW                                    = '[Financial Documents Layout] Set View',
    SET_STATUS                                  = '[Financial Documents Page] Set Status',
    LOAD_COLUMNS                                = '[Financial Documents Layout] Load Columns',
    TOGGLE_COLUMNS                              = '[Financial Documents Layout] Toggle Columns',
    ADD_FILTER                                  = '[Financial Documents Layout] Add Filter',
    REMOVE_FILTER                               = '[Financial Documents Layout] Remove Filter',
    CLEAR_FILTERS                               = '[Financial Documents Layout] Clear Filters',
    // ENABLE_DISPUTE                              = '[Finanial Documents Layout] Enable Dispute',
    // DISABLE_DISPUTE                             = '[Financial Documents Layout] Disable Dispute',
    // ENABLE_REGULAR_PAYMENT                      = '[Financial Documents Layout] Enable Regular Payment',
    // DISABLE_REGULAR_PAYMENT                     = '[Financial Documents Layout] Disable Regular Payment',
    ENABLE_RECONCILE                            = '[Financial Documents Layout] Enable Reconcile',
    DISABLE_RECONCILE                           = '[Financial Documents Layout] Disable Reconcile',
    ENABLE_SPECIAL_INVOICE_CREDIT_REQUEST       = '[Financial Documents Layout] Enable Special Invoice Credit Request',
    DISABLE_SPECIAL_INVOICE_CREDIT_REQUEST      = '[Financiall Documents Layout] Disable Special Invoice Credit Request',
    GO_TO_REGULAR_PAYMENTS                      = '[Financial Documents] Go To Regular Payments',
    GO_TO_CLEARING_PROCESS                      = '[Financial Documents] Go To Clearing Process',
    OPEN_DIALOG                                 = '[Financial Documents] Open Dialog',
    CLOSE_DIALOG                                = '[Financial Documents] Close Dialog'
}

export class EnableDatepicker implements Action {
    readonly type: string = ActionTypes.ENABLE_DATEPICKER;

    constructor(public payload?: any) {}
}

export class DisableDatepicker implements Action {
    readonly type: string = ActionTypes.DISABLE_DATEPICKER;

    constructor(public payload?: any) {}
}

export class EnableStatusOptionByVolumeOfData implements Action {
    readonly type: string = ActionTypes.ENABLE_STATUS_OPTION_BY_VOLUME_OF_DATA;

    constructor(public payload?: any) {}
}

export class DisableStatusOptionByVolumeOfData implements Action {
    readonly type: string = ActionTypes.DISABLE_STATUS_OPTION_BY_VOLUME_OF_DATA;

    constructor(public payload?: any) {}
}

export class SetDatepickerRangeValue implements Action {
    readonly type: string = ActionTypes.SET_DATEPICKER_RANGE_VALUE;

    constructor(public payload: Datepicker) {}
}

export class SetView implements Action {
    readonly type: string = ActionTypes.SET_VIEW;

    constructor(public payload: string) {}
}

export class SetStatus implements Action {
    readonly type: string = ActionTypes.SET_STATUS;

    constructor(public payload: string) {}
}

export class LoadColumns implements Action {
    readonly type: string = ActionTypes.LOAD_COLUMNS;

    constructor(public payload?: any) {}
}

export class ToggleColumns implements Action {
    readonly type: string = ActionTypes.TOGGLE_COLUMNS;

    constructor(public payload: {active: string[], inactive: string[], hidden?: string[]}) {}
}

export class AddFilter implements Action {
    readonly type: string = ActionTypes.ADD_FILTER;

    constructor(public payload: {key: string, value: any}) {}
}

export class RemoveFilter implements Action {
    readonly type: string = ActionTypes.REMOVE_FILTER;

    constructor(public payload: {key: string, value: any}) {}
}

export class ClearFilters implements Action {
    readonly type: string = ActionTypes.CLEAR_FILTERS;

    constructor(public payload?: any) {}
}

// export class EnableDispute implements Action {
//     readonly type: string = ActionTypes.ENABLE_DISPUTE;

//     constructor(public payload?: any) {}
// }

// export class DisableDispute implements Action {
//     readonly type: string = ActionTypes.DISABLE_DISPUTE;

//     constructor(public payload?: any) {}
// }

export class EnableReconcile implements Action {
    readonly type: string = ActionTypes.ENABLE_RECONCILE;

    constructor(public payload?: any) {}
}

export class DisableReconcile implements Action {
    readonly type: string = ActionTypes.DISABLE_RECONCILE;

    constructor(public payload?: any) {}
}

export class EnableSpecialInvoiceCreditRequest implements Action {
    readonly type: string = ActionTypes.ENABLE_SPECIAL_INVOICE_CREDIT_REQUEST;

    constructor(public payload?: any) {}
}

export class DisableSpecialInvoiceCreditRequest implements Action {
    readonly type: string = ActionTypes.DISABLE_SPECIAL_INVOICE_CREDIT_REQUEST;

    constructor(public payload?: any) {}
}

export class OpenDialog implements Action {
    readonly type: string = ActionTypes.OPEN_DIALOG;

    constructor(public payload?: any) {}
}

export class CloseDialog implements Action {
    readonly type: string = ActionTypes.CLOSE_DIALOG;

    constructor(public payload?: any) {}
}

export class GoToRegularPayments implements Action {
    readonly type: string = ActionTypes.GO_TO_REGULAR_PAYMENTS;

    constructor(public payload?: any) {}
}

export class GoToClearingProcess implements Action {
    readonly type: string = ActionTypes.GO_TO_CLEARING_PROCESS;

    constructor(public payload?: any) {}
}

export type Actions =
    | EnableDatepicker | DisableDatepicker
    | SetDatepickerRangeValue
    | SetView | SetStatus
    | LoadColumns | ToggleColumns
    | AddFilter | RemoveFilter | ClearFilters
    // | EnableDispute | DisableDispute
    // | EnableRegularPayment | DisableRegularPayment
    | EnableReconcile | DisableReconcile
    | EnableStatusOptionByVolumeOfData
    | DisableStatusOptionByVolumeOfData
    | EnableSpecialInvoiceCreditRequest | DisableSpecialInvoiceCreditRequest
    | GoToRegularPayments
    | GoToClearingProcess
    | OpenDialog
    | CloseDialog;
